import { render, staticRenderFns } from "./verification-warning.vue?vue&type=template&id=7d099a0a&scoped=true&"
import script from "./verification-warning.vue?vue&type=script&lang=js&"
export * from "./verification-warning.vue?vue&type=script&lang=js&"
import style0 from "./verification-warning.vue?vue&type=style&index=0&id=7d099a0a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d099a0a",
  null
  
)

export default component.exports